<template>
  <Row>
      <Col :span="12">
      <div style="background:#fff;padding:20px;min-height:500px;">
     <BaseForm :form="{
              layout:form.html,
              def:formDef,

              option:{
                hideTools:true
              }
            }"
             editable="true"
          ></BaseForm>
          </div>
      </Col>
      <Col :span="12">
      <div style="padding:10px;">
      HTML视图
      <Button type="primary" @click="$set(form,'html',html)">渲染</Button>
      <Input type="textarea" v-model="html" :rows="12" style="margin:10px 0;" />
      可用数据域
      <p>
      {{form.fields.map(v=>v.key || v.name).join(',')}}
      </p>
      </div>
      </Col>
  </Row>
</template>

<script>
export default {
  data() {
    return {
      html: '',
    };
  },
  mounted() {
    if (this.form.html) {
      this.html = this.form.html;
    }
  },
  props: ['form'],
  computed: {
    formDef() {
      const def = {};
      if (this.form && this.form.fields) {
        this.form.fields.forEach((v)=>{
          def[v.key || v.name] = {
            label: v.name,
            control: 'input',
          };
        });
      }

      return def;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
